import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function Button({ children, to, type = "button", variant = "primary", full = false, disabled = false, onClick }) {
  const className = `btn btn-${variant}${full ? " btn-full" : ""}`;

  const content = (
    <motion.span whileHover={{ y: -2 }} whileTap={{ scale: 0.97 }} className="btn-inner">
      {children}
    </motion.span>
  );

  if (to) {
    return (
      <Link className={className} to={to}>
        {content}
      </Link>
    );
  }

  return (
    <button className={className} type={type} disabled={disabled} onClick={onClick}>
      {content}
    </button>
  );
}
